import React from "react";
import { inject, observer } from "mobx-react";
import HomePageStore from "../HomePageStore";

interface VideoBannerState {
  videoElement: HTMLVideoElement;
  isMuted: boolean;
}

interface VideoBannerProps {}

interface InjectedProps extends VideoBannerProps {
  homePageStore: HomePageStore;
}

class VideoBanner extends React.Component<VideoBannerProps, VideoBannerState> {
  constructor(props: VideoBannerProps) {
    super(props);
    this.state = {
      videoElement: null,
      isMuted: true,
    };
  }
  componentDidMount() {
    this.setState({
      videoElement: document.getElementById("videoPlayer") as HTMLVideoElement,
    });
  }
  render() {
    const { homePageStore } = this.props as InjectedProps;
    const { banner } = homePageStore.homePageContent.response;

    const getVideoPath = () => (window.innerWidth <= 480 ? banner.bannerVideoForMobile : banner.bannerVideoForDesktop);
    const clickThrough = () => {
      if (banner.clickThroughUrl) {
        window.location.href = banner.clickThroughUrl;
      }
    };
    const videoStyle = {
      width: "100%",
      height: window.innerHeight + "px",
    };

    return (
      <section className="pageHero pageHero--full">
        <div
          className="fullBgVideo fullBgVideo__home"
          onClick={(e) => {
            e.preventDefault();
            clickThrough();
          }}
        >
          <video id="videoPlayer" style={videoStyle} className="fullBgVideo__video" playsInline autoPlay muted loop>
            <source type="video/mp4" src={getVideoPath()} />
          </video>
        </div>
        <div
          className="pageHero__content container"
          onClick={(e) => {
            e.preventDefault();
            clickThrough();
          }}
        >
          <div
            className="col-xs-12 col-sm-8 col-sm-offset-2"
            dangerouslySetInnerHTML={{
              __html: homePageStore.homePageContent.response.banner.videoBannerTextOverlay,
            }}
          />
        </div>
        <div
          className="mute-btn"
          onClick={(e) => {
            e.preventDefault();
            this.state.videoElement.muted = !this.state.isMuted;
            this.state.videoElement.defaultMuted = !this.state.isMuted;
            this.setState({
              isMuted: !this.state.isMuted,
            });
          }}
        >
          <span className={this.state.isMuted ? "icon-mute" : "icon-volume"}></span>
        </div>
        <div className="scrollCue"></div>
      </section>
    );
  }
}

export default inject("homePageStore")(observer(VideoBanner));
